import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Evita que se muestren los logs en consola en producción
  // RMG: Deshabilitado solo por el tiempo que testeamos en PROD
  // if (window) {
  //   window.console.log = () => {};
  // }
  // FIN RMG
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
